var _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCardFailed = function SvgCardFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.402 43.273a4.786 4.786 0 0 0 3.385 1.402h54.247a4.786 4.786 0 0 0 4.787-4.787V4.786A4.786 4.786 0 0 0 59.034 0H4.787A4.787 4.787 0 0 0 0 4.787v35.101c0 1.27.504 2.487 1.402 3.385ZM60.63 15.96V9.582H3.191v6.378H60.63ZM3.191 19.152H60.63v20.736a1.596 1.596 0 0 1-1.596 1.596H4.787a1.596 1.596 0 0 1-1.596-1.596V19.152ZM60.63 4.787V6.39H3.191V4.787A1.596 1.596 0 0 1 4.787 3.19h54.247a1.595 1.595 0 0 1 1.596 1.596ZM27.121 28.72H11.166a1.596 1.596 0 0 1 0-3.19h15.955a1.595 1.595 0 1 1 0 3.19Zm-15.955 6.375h9.573a1.595 1.595 0 1 0 0-3.191h-9.573a1.595 1.595 0 1 0 0 3.19Z",
    fill: "#5C7AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.234 26.974c-5.973 0-10.813 4.84-10.813 10.813 0 5.973 4.84 10.813 10.813 10.813 5.973 0 10.813-4.84 10.813-10.813 0-5.972-4.84-10.813-10.813-10.813Zm0 19.454a8.636 8.636 0 0 1-8.64-8.64 8.636 8.636 0 0 1 8.64-8.641 8.636 8.636 0 0 1 8.64 8.64 8.636 8.636 0 0 1-8.64 8.64Z",
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.234,
    cy: 37.787,
    r: 9.191,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.255 42.894a1.021 1.021 0 1 1-2.042 0 1.021 1.021 0 0 1 2.042 0ZM59.234 40.85c.562 0 1.021-.306 1.021-.68v-7.83c0-.374-.46-.68-1.021-.68-.562 0-1.021.306-1.021.68v7.83c0 .374.46.68 1.02.68Z",
    fill: "#EC4E58"
  })));
};

export default SvgCardFailed;